import styled from 'styled-components/macro';

export default styled('div')`
  color:  ${(props) => props.theme.colors.red};
  font-size: 13px;
`;
